var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-tags"},_vm._l((_vm.tags),function(tag,index){return _c('a',{staticClass:"social-tag",attrs:{"href":tag.link,"target":"_blank","rel":"noopener","title":"Open in new tab"}},[_c('i',{staticClass:"bx bx-6",class:[tag.icon]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }